var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Check_circle--blue"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Background",
  fill: "#1984EC",
  cx: 12,
  cy: 12,
  r: 8
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Check",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "10.5030062 13.6454496 15.2546675 8.3333071 16.7453325 9.6666929 10.7631073 16.3545504 7.39513206 13.7963258 8.60486794 12.2036742"
})))));
export { SvgCheckBlue as ReactComponent };
export default __webpack_public_path__ + "static/media/checkBlue.87a80f44.svg";